import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { ContactMethod } from '../models/contact-method.model';

@Component({
  selector: 'contact-methods-selector',
  template: require('./contact-methods-selector.component.html'),
  styles: [require('./contact-methods-selector.component.scss')],
})
export class ContactMethodsSelectorComponent implements OnChanges {
  @Input() locked: boolean = false;
  @Input() selected: number;
  @Input() contactMethods: ContactMethod[];

  @Output() selectedNumberChange: EventEmitter<number> = new EventEmitter<number>();

  kinds: string[] = ['home', 'mobile', 'work', 'other'];

  ngOnChanges(): void {
    if (!this.selected && this.contactMethods.length) {
      this.selectedNumberChange.emit(this.contactMethods[0].displaySequence);
    }
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/contact-methods-selector/contact-methods-selector.component.ts